import React, { useMemo } from 'react';
import { SkeletonTheme, SkeletonThemeProps } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import { getCssVariableValue } from '@eika-infrastruktur/utils';

type SkeletonThemeProviderProps = React.PropsWithChildren & SkeletonThemeProps;

const SkeletonThemeProvider: React.FC<SkeletonThemeProviderProps> = ({
    children,
    baseColor,
    highlightColor,
    ...rest
}) => {
    const baseColorContext = useMemo(() => baseColor ?? getCssVariableValue('--white'), [baseColor]);
    const highlightColorContext = useMemo(
        () => highlightColor ?? getCssVariableValue('--card-background-light'),
        [highlightColor],
    );

    return (
        <SkeletonTheme baseColor={baseColorContext} highlightColor={highlightColorContext} {...rest}>
            {children}
        </SkeletonTheme>
    );
};

export default SkeletonThemeProvider;
